export default __webpack_public_path__ + "static/media/logo.b1b820f0.png";